import InfoHint from "../components/InfoHint";
import { fmtEUR } from "../lib/auth";
import { useDepots, useRecs } from "./data";
import type { WidgetComponentProps } from "./registry";

export default function NetWorthWidget(_props: WidgetComponentProps) {
  const recs = useRecs();
  const depots = useDepots();
  const konten = (recs ?? []).reduce((s, r) => s + Number(r.rec.kontostand), 0);
  const depotsTotal = (depots ?? []).reduce((s, d) => s + Number(d.total_value), 0);
  const netWorth = konten + depotsTotal;
  const hasDepots = (depots ?? []).length > 0;
  const hint = (
    <InfoHint
      label="Was ist das Gesamtvermögen?"
      text="Summe aller Kontostände plus der aktuelle Marktwert aller Depots."
    />
  );
  if (!hasDepots) {
    return (
      <section className="card p-4 flex items-baseline justify-between gap-3">
        <div className="flex items-center gap-1.5 text-xs uppercase tracking-wide text-ink-400">
          Gesamtvermögen {hint}
        </div>
        <div className="num text-2xl font-semibold text-ink-100">{fmtEUR(netWorth)}</div>
      </section>
    );
  }
  return (
    <section className="card p-4">
      <div className="flex items-baseline justify-between gap-3 mb-2">
        <div className="flex items-center gap-1.5 text-xs uppercase tracking-wide text-ink-400">
          Gesamtvermögen {hint}
        </div>
        <div className="num text-2xl font-semibold text-ink-100">{fmtEUR(netWorth)}</div>
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="rounded-lg border border-ink-800 bg-ink-950/40 px-3 py-2">
          <div className="text-[11px] text-ink-500">Konten</div>
          <div className="num text-base font-semibold text-ink-100">{fmtEUR(konten)}</div>
        </div>
        <div className="rounded-lg border border-ink-800 bg-ink-950/40 px-3 py-2">
          <div className="text-[11px] text-ink-500">Depots</div>
          <div className="num text-base font-semibold text-ink-100">{fmtEUR(depotsTotal)}</div>
        </div>
      </div>
    </section>
  );
}
